import FetchData from '@ezviz/FetchData';
import moment from "moment";
import { message } from "antd";
import intl from 'react-intl-universal'
import util from './../../utils/utils';
// 获取应用列表
export const FETCH_APPLICATION_LIST_SUCCESS = "FETCH_APPLICATION_LIST_SUCCESS";
export const FETCH_APPLICATION_LIST_FAILED = "FETCH_APPLICATION_LIST_FAILED";
export const FETCH_APPLICATION_LIST_LOADING = "FETCH_APPLICATION_LIST_LOADING";
// 获取单个应用详情
export const FETCH_APPLICATION_DETAIL_SUCCESS = "FETCH_APPLICATION_DETAIL_SUCCESS";
export const FETCH_APPLICATION_DETAIL_FAILED = "FETCH_APPLICATION_DETAIL_FAILED";
export const FETCH_APPLICATION_DETAIL_LOADING = "FETCH_APPLICATION_DETAIL_LOADING";
// 获取单个应用详情配置
export const FETCH_APPLICATION_DETAIL_INFO_SUCCESS = "FETCH_APPLICATION_DETAIL_INFO_SUCCESS";
export const FETCH_APPLICATION_DETAIL_INFO_FAILED = "FETCH_APPLICATION_DETAIL_INFO_FAILED";
export const FETCH_APPLICATION_DETAIL_INFO_LOADING = "FETCH_APPLICATION_DETAIL_INFO_LOADING";
// 获取默认应用信心
export const FETCH_APPLICATION_DEFAULT_SUCCESS = "FETCH_APPLICATION_DEFAULT_SUCCESS";
export const FETCH_APPLICATION_DEFAULT_FAILED = "FETCH_APPLICATION_DEFAULT_FAILED";
export const FETCH_APPLICATION_DEFAULT_LOADING = "FETCH_APPLICATION_DEFAULT_LOADING";
// 配置单个应用用户界面
export const FETCH_APPLICATION_DETAIL_INTERFACE_SET_SUCCESS = "FETCH_APPLICATION_DETAIL_INTERFACE_SET_SUCCESS";
export const FETCH_APPLICATION_DETAIL_INTERFACE_SET_FAILED = "FETCH_APPLICATION_DETAIL_INTERFACE_SET_FAILED";
export const FETCH_APPLICATION_DETAIL_INTERFACE_SET_LOADING = "FETCH_APPLICATION_DETAIL_INTERFACE_SET_LOADING";
// 创建应用
export const FETCH_APPLICATION_CREATE_SUCCESS = "FETCH_APPLICATION_CREATE_SUCCESS";
export const FETCH_APPLICATION_CREATE_FAILED = "FETCH_APPLICATION_CREATE_FAILED";
export const FETCH_APPLICATION_CREATE_LOADING = "FETCH_APPLICATION_CREATE_LOADING";
// 编辑单个应用
export const FETCH_APPLICATION_EDIT_SUCCESS = "FETCH_APPLICATION_EDIT_SUCCESS";
export const FETCH_APPLICATION_EDIT_FAILED = "FETCH_APPLICATION_EDIT_FAILED";
export const FETCH_APPLICATION_EDIT_LOADING = "FETCH_APPLICATION_EDIT_LOADING";
// 删除单个应用
export const FETCH_APPLICATION_DEL_SUCCESS = "FETCH_APPLICATION_DEL_SUCCESS";
export const FETCH_APPLICATION_DEL_FAILED = "FETCH_APPLICATION_DEL_FAILED";
export const FETCH_APPLICATION_DEL_LOADING = "FETCH_APPLICATION_DEL_LOADING";
// 获取功能选配
export const FETCH_CHOOSE_LIST = "FETCH_CHOOSE_LIST";
// 获取配网列表
export const FETCH_CATEGORYS = "FETCH_CATEGORYS";
// 获取自定义配网列表
export const FETCH_CUSTOM_CATEGORYS = "FETCH_CUSTOM_CATEGORYS";
// 获取静态配置数据
export const FETCH_DEFAULT_CONFIG = "FETCH_DEFAULT_CONFIG";

// 设置创建应用弹框展示
export const SET_APPLICATIONMODALVISIBLE = 'SET_APPLICATIONMODALVISIBLE';

// 重置数据
export const RESET_DATA = 'RESET_DATA';


moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

// 获取应用列表
export function fetchApplicationList(param) {
  return (dispatch, getState) => {
    const {
      pageStart = 0,
      pageSize = 10,
    } = param;
    dispatch({
      type: FETCH_APPLICATION_LIST_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/apps?pageStart=${pageStart}&pageSize=${pageSize}`, {
      method: 'GET',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_LIST_SUCCESS,
            applicationList: res.data || [],
            applicationListPage: res.page || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_LIST_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_LIST_FAILED,
        });
      });
  };
}

// 编辑
export function editApplication(param) {
  return (dispatch, getState) => {
    const {
      appId,
      appName,
      androidName,
      bundleId,
    } = param;
    const body = {
      appName,
      androidName,
      bundleId,
    }
    dispatch({
      type: FETCH_APPLICATION_EDIT_LOADING,
    });
    const fetchData = new FetchData('/iot/config/api/iot/support/v1/app', {
      method: 'PUT',
      body,
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_EDIT_SUCCESS,
          });
          dispatch(fetchApplicationList({}));
          dispatch(setApplicationModalVisible(false));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_EDIT_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_EDIT_FAILED,
        });
      });
  };
}
// 创建
export function crateApplication(param, callback) {
  return (dispatch, getState) => {
    const {
      appName,
      androidName,
      bundleId,
    } = param;
    const body = {
      appName,
      androidName,
      bundleId,
    }
    dispatch({
      type: FETCH_APPLICATION_CREATE_LOADING,
    });
    const fetchData = new FetchData('/iot/config/api/iot/support/v1/app', {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_CREATE_SUCCESS,
          });
          dispatch(fetchApplicationList({}));
          dispatch(setApplicationModalVisible(false));
          callback && callback(res.data);
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_CREATE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_CREATE_FAILED,
        });
      });
  };
}

// 删除
export function deleteApplication(param) {
  return (dispatch, getState) => {
    const {
      appId,
    } = param;
    dispatch({
      type: FETCH_APPLICATION_DEL_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/app?appId=${appId}`, {
      method: 'DELETE',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_DEL_SUCCESS,
          });
          dispatch(fetchApplicationList({}));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_DEL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_DEL_FAILED,
        });
      });
  };
}

// 获取单个应用详情
export function fetchApplicationDetail(param) {
  return (dispatch, getState) => {
    const {
      appId,
    } = param;
    dispatch({
      type: FETCH_APPLICATION_DETAIL_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/app?appId=${appId}`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_DETAIL_SUCCESS,
            applicationDetail: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_DETAIL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_DETAIL_FAILED,
        });
      });
  };
}

// 获取单个应用详情配置
export function fetchApplicationDetailInfo(param, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    dispatch({
      type: FETCH_APPLICATION_DETAIL_INFO_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/getAppIdDetailInfo?appId=${appId}`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_DETAIL_INFO_SUCCESS,
            applicationDetailInfo: res.data || []
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_DETAIL_INFO_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_DETAIL_INFO_FAILED,
        });
      });
  };
}

// 配置单个应用用户界面
export function fetchApplicationDetailInterfaceSet(param = {}) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const { module, content, appItem, language = 'zh_CN' } = param;
    const body = {
      module, content, appItem, language
    }
    dispatch({
      type: FETCH_APPLICATION_DETAIL_INTERFACE_SET_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/app/item`, {
      method: 'PUT',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch(fetchApplicationDetailInfo())
          dispatch({
            type: FETCH_APPLICATION_DETAIL_INTERFACE_SET_SUCCESS,
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_DETAIL_INTERFACE_SET_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_DETAIL_INTERFACE_SET_FAILED,
        });
      });
  };
}

// 获取默认应用配置信息
export function fetchApplicationDefault(param = {}) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    dispatch({
      type: FETCH_APPLICATION_DEFAULT_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/default`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_DEFAULT_SUCCESS,
            applicationDefault: res.data,
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_DEFAULT_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_DEFAULT_FAILED,
        });
      });
  };
}

// 获取功能选配数据
export function fetchChooseList(param, callback) {
  return (dispatch, getState) => {
    const {
      appId,
    } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/function/choose`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          callback(res.data);
          dispatch({
            type: FETCH_CHOOSE_LIST,
            chooseList: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          // dispatch({
          //   type: FETCH_APPLICATION_LIST_FAILED,
          // });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 保存功能选配数据
export function saveChooseList(param, callback) {
  return (dispatch, getState) => {
    const body = param;
    const appId = window.applicationId;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/function/choose`, {
      method: 'PUT',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          callback(res.data);
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 获取标准类目列表
export function fetchCategorys(param, callback) {
  return (dispatch, getState) => {
    const {
      appId,
    } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/network/categorys`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_CATEGORYS,
            categorys: res.data || []
          });
          callback(res.data || [])
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          // dispatch({
          //   type: FETCH_APPLICATION_LIST_FAILED,
          // });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}


// 获取自定义类目列表
export function fetchCustomCategorys(param, callback) {
  return (dispatch, getState) => {
    const {
      appId,
    } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/custom/categorys`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          dispatch({
            type: FETCH_CUSTOM_CATEGORYS,
            customCategorys: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 保存自定义类目列表
export function saveCustomCategorys(param, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/custom/categorys`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res)
        if (res.code != 200) {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 获取默认数据
export function fetchDefaultConfig(param, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/default`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          dispatch({
            type: FETCH_DEFAULT_CONFIG,
            defaultConfig: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 保存自定义类目列表
export function saveClientInfo(param, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/client/info`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res)
        if (res.code != 200) {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        } else {
          message.success(intl.get('home.product.feature.saveSuccess'));
        }
      })
      .catch(e => {
        callback('failed')
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 删除自定义类目
export function deleteCategory(param, callback) {
  return (dispatch, getState) => {
    const {categoryId} = param;
    const appId = window.applicationId;
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/custom/category/${categoryId}`, {
      method: 'DELETE',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res)
        if (res.code != 200) {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 更换类目图片
export function putCategory(param, callback) {
  return (dispatch, getState) => {
    const {categoryId, url, label} = param;
    const appId = window.applicationId;
    console.log('url', url)
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/custom/category/${categoryId}?url=${url}&label=${label}`, {
      method: 'PUT',
      headers: {
        appId,
      },
      // body: url,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res)
        if (res.code != 200) {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 设置创建应用弹框展示
export function setApplicationModalVisible(visible) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_APPLICATIONMODALVISIBLE,
      applicationModalVisible: visible,
    });
  };
}

// 重置数据，应用列表点击配置应用入口时调用
export function resetData() {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_DATA,
    });
  };
}


